import { render, staticRenderFns } from "./ElementDescription.vue?vue&type=template&id=10b9c1c2&scoped=true&lang=html"
import script from "./ElementDescription.vue?vue&type=script&lang=js"
export * from "./ElementDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9c1c2",
  null
  
)

export default component.exports